// @flow
import numeral from 'numeral';
import viewHelpers from '@src/viewHelpers';
import * as routes from '@src/app_routes/diamonds';
import { shapeNames } from '@src/utils/displayMaps';
import type { DiamondType } from '@types/diamond';

const currencyFormat = '$0,0';

type PropsType = {
  onRemoveClick: (ID: string) => void,
  diamond: DiamondType
};

export default class LegacyComparisonGridDiamondItem extends React.Component<PropsType> {
  handleRemoveClick = (e: SyntheticMouseEvent<HTMLLinkElement>) => {
    e.preventDefault();
    this.props.onRemoveClick(this.props.diamond.list_service_diamond_id);
  };

  render() {
    const { diamond } = this.props;

    return (
      <td>
        <table className='compare-table'>
          <tbody>
            <tr>
              <td style={{ height: '30px' }}>{shapeNames[diamond.shape]}</td>
            </tr>
            <tr>
              <td style={{ height: '85px' }}>
                {viewHelpers.compareSizeDiamond(diamond)}
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                <a
                  href={
                    diamond.has_compatible_settings
                      ? routes.detailPath(diamond)
                      : routes.looseDetailPath(diamond)
                  }
                  className='view'
                >
                  View
                </a>
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                <a onClick={this.handleRemoveClick}>remove</a>
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                {numeral(diamond.retail_price).format(currencyFormat)}
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.carat}</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                {diamond.final_cut_grade || ''}
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.color}</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.clarity}</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.vendor_polish || ''}</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                {diamond.vendor_symmetry || ''}
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.lab}</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                {parseFloat(diamond.length_width_ratio).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style={{ height: '40px' }}>
                {viewHelpers.measurementLong(diamond)}
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.vendor_depth}%</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.vendor_table}%</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.vendor_fluorescence}</td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>{diamond.vendor_culet}</td>
            </tr>
            <tr>
              <td style={{ height: '40px' }}>
                {viewHelpers.girdleLong(diamond) || (
                  <a
                    target='_blank'
                    href={diamond.certificate_url}
                    style={{ color: '#1c487e', textDecoration: 'underline' }}
                  >
                    see certificate
                  </a>
                )}
              </td>
            </tr>
            <tr>
              <td style={{ height: '40px' }}>
                {numeral(diamond.retail_price_per_carat).format(currencyFormat)}{' '}
                per carat
              </td>
            </tr>
            <tr>
              <td style={{ height: '30px' }}>
                {diamond.list_service_diamond_id}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    );
  }
}
